var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/stream-browserify/node_modules/isarray/index.js
// module id = 1168
// module chunks = 0